import(/* webpackMode: "eager", webpackExports: ["BooksFilmsClient"] */ "/opt/buildhome/repo/src/components/books-films/books-films-client.tsx");
